import React from "react";

export interface IconProps {
  width?: number;
  height?: number;
  color?: string;
}

export default function DuplicateIcon(props: IconProps): JSX.Element {
  const { width, height, color } = props;
  return (
    <svg width={width || 14} height={height || 16} viewBox="0 0 14 16">
      <path
        d="M13.561-11.939L11.94-13.56a1.723 1.723 0 00-1.061-.44H5.5A1.5 1.5 0 004-12.5v1.5H1.5A1.5 1.5 0 000-9.5v10A1.5 1.5 0 001.5 2h7A1.5 1.5 0 0010 .5V-1h2.5A1.5 1.5 0 0014-2.5v-8.379a1.723 1.723 0 00-.439-1.06zM8.312.5H1.687A.188.188 0 011.5.312v-9.624a.188.188 0 01.187-.188H4v7A1.5 1.5 0 005.5-1h3V.312A.188.188 0 018.312.5zm4-3H5.687a.188.188 0 01-.187-.187v-9.625a.188.188 0 01.188-.187H9v2.75A.75.75 0 009.75-9h2.75v6.312a.188.188 0 01-.188.188zm.188-8h-2v-2h.3a.188.188 0 01.133.055l1.512 1.512a.215.215 0 01.055.133z"
        transform="translate(0 14)"
        fill={color || "#bbb"}
      />
    </svg>
  );
}
